import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';

import { Column } from '../../../../../../../../../shared/design-system/components/organisms/table/types';

import PhoneNumberField from '../fields/phone-number-field';
import AddedByField from '../fields/added-by-field';
import AddedOnField from '../fields/added-on-field';
import hasPermission from '../../../../../../../../../shared/utils/access-control/has-permission';
import { Permissions } from '../../../../../../../../../shared/utils/access-control/enums/permissions';
import { DoNotCallListPhoneNumber } from '../../../../../../../types/do-not-call-list';

export const getDoNotCallListDetailsColumns = (): Column[] => {
  const isActionsColVisible = hasPermission(
    Permissions.DNC_LIST_DELETE,
  );

  return [
    {
      dataField: 'phoneNumber',
      text: 'Phone Number',
      headerAlign: 'start',
      cellClasses: 'email-domain-name-cell',
      component: (_cell, row: DoNotCallListPhoneNumber) => (
        <PhoneNumberField phoneNumber={row} />
      ),
      ...(isActionsColVisible && {
        headerStyle: () => ({ minWidth: '38.46%', width: '38.46%' }),
      }),
      headerLoadingSkeleton: <SkeletonLoading width={80} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={180} height={14} />,
    },
    {
      dataField: 'user',
      text: 'Added By',
      headerAlign: 'start',
      cellClasses: 'added-by-cell',
      component: (_cell, row: DoNotCallListPhoneNumber) => (
        <AddedByField phoneNumber={row} />
      ),
      headerStyle: () => ({ minWidth: '30%', width: '30%' }),
      headerLoadingSkeleton: <SkeletonLoading width={62} height={14} />,
      cellLoadingSkeleton: (
        <SkeletonLoading width={32} height={24} borderRadius={20} />
      ),
    },
    {
      dataField: 'createdAt',
      text: 'Added On',
      headerAlign: 'start',
      cellClasses: 'updated-at-cell',
      component: (_cell, row: DoNotCallListPhoneNumber) => (
        <AddedOnField phoneNumber={row} />
      ),
      headerStyle: () => ({ minWidth: '25%', width: '25%' }),
      headerLoadingSkeleton: <SkeletonLoading width={62} height={14} />,
      cellLoadingSkeleton: (
        <SkeletonLoading width={32} height={24} borderRadius={20} />
      ),
    },
  ];
};
